// Footer organism component
import { useLandingContent } from "../../contexts/LandingContentContext";

export const Footer = () => {
  const { footer } = useLandingContent();

  return (
    <footer
      id="footer"
      className="bg-ink text-paper/80 py-10 border-t border-white/5"
    >
      <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        {/* Brand mark */}
        <p className="font-display text-paper/90 text-sm font-medium tracking-wide">
          {footer.brand}
        </p>

        {/* Copyright */}
        <p className="text-xs text-paper/50 tracking-wide">
          {footer.copyright}
        </p>

        {/* Verse accent */}
        <p className="text-xs italic text-terracotta-300 tracking-wide">
          {footer.scripture}
        </p>
      </div>
    </footer>
  );
};
